/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_S4Inputs */

const en_tut_rekam_s4 = /** @type {(inputs: Tut_Rekam_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once the status is **Siap**, open the **Rekaman** tab and choose **Putar rekaman** or **Unduh MP4**.`)
};

const id_tut_rekam_s4 = /** @type {(inputs: Tut_Rekam_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah statusnya **Siap**, buka tab **Rekaman** lalu **Putar rekaman** atau **Unduh MP4**.`)
};

/**
* | output |
* | --- |
* | "Once the status is **Siap**, open the **Rekaman** tab and choose **Putar rekaman** or **Unduh MP4**." |
*
* @param {Tut_Rekam_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_s4 = /** @type {((inputs?: Tut_Rekam_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_s4(inputs)
	return en_tut_rekam_s4(inputs)
});